import React from 'react';
import TeamHeroImg from '../assets/team.png';
import Armel from '../assets/Photos/Armel4.jpg';
import Vicky from '../assets/Photos/Vicky4.jpg';
import ASHACert from '../assets/certified.png';

const Team = () => {
  return (
    <>
      {/* Banner */}
      <section className="banner">
        <img
          id="banner-img"
          src={TeamHeroImg}
          alt="Meet Our Professional Speech Therapy Team"
        />
      </section>

      {/* Main Content */}
      <div className="container py-5">
        {/* Page Header */}
        <section className="row mb-5">
          <div className="col-lg-8 mx-auto text-center fade-up">
            <h1 className="display-5 fw-bold mb-3">Meet Our Expert Team</h1>
            <p className="lead text-muted">
              Licensed speech-language pathologists dedicated to helping you achieve your communication goals
            </p>
          </div>
        </section>

        {/* Team Members */}
        <section className="row g-5 justify-content-center mb-5">
          {/* Armel */}
          <div className="col-lg-5 fade-up">
            <div className="card team-card border-0 shadow-sm h-100">
              <div className="row g-0 h-100">
                <div className="col-md-5 d-flex align-items-center">
                  <img
                    src={Armel}
                    className="img-fluid rounded-start"
                    alt="John Doe, M.S., CCC-SLP"
                    style={{ objectFit: 'cover', height: '100%', width: '100%' }}
                  />
                </div>
                <div className="col-md-7">
                  <div className="card-body p-4 d-flex flex-column h-100">
                    <div>
                      <h4 className="fw-bold mb-1">Armel Alvarez</h4>
                      <p className="text-primary fw-semibold mb-3">M.S., CCC-SLP</p>
                      <p className="mb-3">
                        Armel brings extensive experience in pediatric and adult speech therapy,
                        specializing in bilingual services and evidence-based treatment approaches.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Vicky */}
          <div className="col-lg-5 fade-up">
            <div className="card team-card border-0 shadow-sm h-100">
              <div className="row g-0 h-100">
                <div className="col-md-5 d-flex align-items-center">
                  <img
                    src={Vicky}
                    className="img-fluid rounded-start"
                    alt="Maria Victoria Alvarez, M.S., CCC-SLP"
                    style={{ objectFit: 'cover', height: '100%', width: '100%' }}
                  />
                </div>
                <div className="col-md-7">
                  <div className="card-body p-4 d-flex flex-column h-100">
                    <div>
                      <h4 className="fw-bold mb-1">Vicky Alvarez</h4>
                      <p className="text-primary fw-semibold mb-3">M.S., CCC-SLP</p>
                      <p className="mb-3">
                        As a bilingual specialist, Vicky excels at comprehensive communication assessments and personalized therapy plans, always with a focus on family-centered care.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Team Credentials */}
        <section className="row mb-5">
          <div className="col-lg-10 mx-auto">
            <div className="p-5 rounded-4 shadow-sm bg-white fade-up">
              <div className="row align-items-center">
                <div className="col-lg-8">
                  <h3 className="fw-bold mb-3 text-center">Licensed & Certified Professionals</h3>
                  <p className="fs-5 mb-4">
                    Our Speech-Language Pathologists are licensed in NC, SC, FL, and TX, and hold national certification
                    with the American Speech-Language Hearing Association (ASHA).
                  </p>
                  <div className="row g-4">
                    <div className="col-md-6 d-flex align-items-start">
                      <div
                        className="bg-success bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center me-3"
                        style={{ width: 40, height: 40 }}
                      >
                        <span className="text-success fw-bold">✓</span>
                      </div>
                      <div>
                        <h6 className="fw-bold mb-1">Multi-State Licensed</h6>
                        <p className="text-muted small mb-0">North Carolina, South Carolina, Florida, Texas</p>
                      </div>
                    </div>
                    <div className="col-md-6 d-flex align-items-start">
                      <div
                        className="bg-success bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center me-3"
                        style={{ width: 40, height: 40 }}
                      >
                        <span className="text-success fw-bold">✓</span>
                      </div>
                      <div>
                        <h6 className="fw-bold mb-1">ASHA Certified</h6>
                        <p className="text-muted small mb-0">Certificate of Clinical Competence</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 text-center">
                  <img
                    src={ASHACert}
                    alt="ASHA Certified"
                    className="img-fluid"
                    style={{ maxWidth: 180, marginTop: '20px', marginBottom: '20px', textAlign: 'center' }}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Team;
